// extracted by mini-css-extract-plugin
export default {"section13__draw":"BgLine13--section13__draw--8MEg3","path__draw__1":"BgLine13--path__draw__1--stRSC"};